import {
	ShipmentStatusCount,
	ShipmentStatusCountShipmentStatus,
} from '@uturn/api/v1';
import { LinkProps } from './shipment-group-card.types';
import { PickedStatus } from './types';

export const getShipmentStatusLinkProps = (
	groupId: number,
): Record<PickedStatus, LinkProps> => {
	return {
		[PickedStatus.CONCEPT]: {
			to: '/shipments/groups/$groupId/drafted',
			params: { groupId },
		},
		[PickedStatus.PUBLISHED]: {
			to: '/shipments/groups/$groupId',
			params: { groupId },
			search: { 'filter.statuses': ['PUBLISHED'] },
		},
		[PickedStatus.QUOTED]: {
			to: '/shipments/groups/$groupId',
			params: { groupId },
			search: { 'filter.statuses': ['QUOTED'] },
		},
		[PickedStatus.CARRIER_ASSIGNED]: {
			to: '/shipments/groups/$groupId/assigned',
			params: { groupId },
		},
		[PickedStatus.COMPLETED]: {
			to: '/shipments/groups/$groupId/archived',
			params: { groupId },
		},
	};
};

export const getDefaultShipmentStatusLinkProps = (
	groupId: number,
): LinkProps => ({
	to: '/shipments/groups/$groupId',
	params: { groupId },
});

export const getShipmentCount = (
	shipmentStatusCount: ShipmentStatusCount[],
	statuses?: ShipmentStatusCountShipmentStatus[],
) => {
	let rows = structuredClone(shipmentStatusCount);
	if (statuses && statuses.length) {
		rows = rows.filter(
			(row) => row.shipmentStatus && statuses.includes(row.shipmentStatus),
		);
	}
	return rows.reduce(
		(accumulator, shipmentStatus) => accumulator + (shipmentStatus.count ?? 0),
		0,
	);
};
